import { render, staticRenderFns } from "./menuPrefacturas.vue?vue&type=template&id=864a8040"
import script from "./menuPrefacturas.vue?vue&type=script&lang=js"
export * from "./menuPrefacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports